import { render, staticRenderFns } from "./Participants.vue?vue&type=template&id=789ee6c8&scoped=true&"
import script from "./Participants.vue?vue&type=script&lang=js&"
export * from "./Participants.vue?vue&type=script&lang=js&"
import style0 from "./Participants.vue?vue&type=style&index=0&id=789ee6c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789ee6c8",
  null
  
)

export default component.exports